var _rect, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame1618867780(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 84,
    viewBox: "0 0 184 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 183,
    height: 83,
    rx: 7.5,
    stroke: "#D0D5DD"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21020_57453)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21020_57453",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 30,
    width: 60,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.749 30.4336H62V53.5661H121.749V30.4336Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21020_57453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.747 30.4336H118.447C117.531 30.4336 116.675 30.887 116.161 31.6452L111.747 38.1563C111.63 38.329 111.375 38.329 111.257 38.1563L106.844 31.6452C106.33 30.887 105.474 30.4336 104.558 30.4336H101.258L109.12 42.0322L101.301 53.5661H104.602C105.517 53.5661 106.373 53.1127 106.887 52.3546L111.257 45.908C111.375 45.7353 111.63 45.7353 111.747 45.908L116.118 52.3546C116.631 53.1127 117.488 53.5661 118.403 53.5661H121.704L113.884 42.0322L121.747 30.4336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4688 32.7998V53.5661H96.0461C97.3533 53.5661 98.4126 52.507 98.4126 51.1999V30.4336H96.8353C95.528 30.4336 94.4688 31.4927 94.4688 32.7998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5763 30.4336H90.1725C88.627 30.4336 87.288 31.5024 86.9455 33.0091L83.8052 46.8138L81.0567 33.9274C80.5482 31.5458 78.1045 29.9397 75.6039 30.6304C74.0111 31.0702 72.8303 32.4159 72.4858 34.0316L69.7652 46.7964L66.6308 33.0101C66.2873 31.5034 64.9483 30.4336 63.4027 30.4336H62L67.2608 53.5652H69.2539C71.0628 53.5652 72.6257 52.3005 73.0029 50.5314L76.366 34.7493C76.4075 34.5535 76.5831 34.4117 76.7828 34.4117C76.9825 34.4117 77.1581 34.5535 77.1996 34.7493L80.5656 50.5324C80.9428 52.3015 82.5057 53.5652 84.3146 53.5652H86.3145L91.5763 30.4336Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21020_57453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 23.1325,
    fill: "white",
    transform: "translate(62 30.4336)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1618867780);
export default __webpack_public_path__ + "static/media/Frame 1618867780.4e0ee22d1b02707baff4143ea8145575.svg";
export { ForwardRef as ReactComponent };